<script>
  import { InlineNotification } from "carbon-components-svelte"
  
  export let notification = {};
  // `onRemove` function will be passed into your component.
  export let onRemove = null;

  const handleButtonClick = () => {
    onRemove();
  }
</script>


<InlineNotification
  kind={notification.type}
  lowContrast
  title={notification.type.charAt(0).toUpperCase() + notification.type.slice(1) + ':'}
  subtitle={notification.text}
  timeout="10000"
  />
